export default "__VITE_ASSET__B6Emc3gF__"